export const WITHDRAWS_LOADING = 'WITHDRAWS_LOADING';
export const WITHDRAWS_ERROR = 'WITHDRAWS_ERROR';
export const WITHDRAWS_SUCCESS = 'WITHDRAWS_SUCCESS';
